import React from "react";
import { Grid } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import SettingsCard from "./SettingsCard";

const CustomerInfoSection = ({ inputData, autoSaveField }) => {
  const save = (e) => {
    if (autoSaveField) autoSaveField(e.target.name, e.target.value);
  };
  return (
    <SettingsCard
      title="Customer Info"
      subtitle="Configure customer contact information"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)",
            marginRight: "24px"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <FormField
            label="Email"
            placeholder="example@email.com"
            inputProps={{ type: "email" }}
            name="email"
            defaultValue={inputData?.email}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12}>
          <SoftTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            textTransform="capitalize"
          >
            Name
          </SoftTypography>
          <SoftInput
            label="Name"
            placeholder="Enter Name"
            inputProps={{ type: "name" }}
            name={"name"}
            defaultValue={inputData?.name}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            label="Phone Number"
            placeholder="(555) 123-4567"
            inputProps={{ type: "phone" }}
            name={"phone_number"}
            defaultValue={inputData?.phone_number}
            onBlur={save}
          />
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default CustomerInfoSection;
